import { api, SubscriptionStatus } from "./api";

// F3: `GET /subscription/status` bir sayfa açılışında üç yerden isteniyordu
// (dashboard, AppShell, fiyatlandırma). Kısa ömürlü promise önbelleği: aynı
// 30 saniye içindeki çağrılar tek isteği paylaşır. Ödeme/iptal gibi durumu
// değiştiren işlemler `invalidateSubscriptionStatus()` ile önbelleği düşürür.
const TTL_MS = 30_000;

let cached: { at: number; promise: Promise<SubscriptionStatus> } | null = null;

export function getSubscriptionStatus(options?: { fresh?: boolean }): Promise<SubscriptionStatus> {
  const now = Date.now();
  if (!options?.fresh && cached && now - cached.at < TTL_MS) return cached.promise;
  const promise = api.getSubscriptionStatus().catch((e) => {
    // Başarısız istek önbellekte kalmasın: bir sonraki çağrı yeniden dener.
    if (cached?.promise === promise) cached = null;
    throw e;
  });
  cached = { at: now, promise };
  return promise;
}

export function invalidateSubscriptionStatus(): void {
  cached = null;
}
